import BinaryDataHeaderSerializer from './binaryData/HeaderSerializer';
import IntsSerializer from './binaryData/IntsSerializer';
import RttSerializer from './binaryData/RttSerializer';
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_10';

const v0_0_10: SerializerRegistry = {
    version,
    binary: {
        HeaderSerializer: new (BinaryDataHeaderSerializer as any)(version),
        RttSerializer: new (RttSerializer as any)(version),
        IntsSerializer: new (IntsSerializer as any)(version),
    },
};

export default v0_0_10;
